import React from 'react';
import { Provider } from '@adobe/react-spectrum';
import { customTheme } from 'app/components/Theme';
import { getColorScheme } from 'app/utils/varia';
export const Spectrum = (props) => {
    var _a;
    return (React.createElement(Provider, { theme: customTheme, flex: "1 1", colorScheme: (_a = props.colorScheme) !== null && _a !== void 0 ? _a : getColorScheme(), height: "100%", maxHeight: "100%" }, props.children));
};
